import { Component, OnInit } from '@angular/core';
import { E5coreUiAssignUserBaseComponent } from './e5core-ui-work-assign-user-base';

@Component({
  selector: 'e5core-ui-work-assign-user-material',
  templateUrl: './e5core-ui-work-assign-user-material.component.html',
  styleUrls: ['./e5core-ui-work-assign-user-material.component.css'],
  providers: [ {provide: E5coreUiAssignUserBaseComponent, useExisting: E5coreUiAssignUserMaterialComponent }]
})
export class E5coreUiAssignUserMaterialComponent extends E5coreUiAssignUserBaseComponent implements OnInit{
}